import { render, staticRenderFns } from "./TicketTeamWord.vue?vue&type=template&id=8541ec56"
import script from "./TicketTeamWord.vue?vue&type=script&lang=js"
export * from "./TicketTeamWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports